import { Injectable } from '@angular/core';

import { ApiService } from '@dav-core/services/api.service';
import { ConfigService } from '@dav-core/services/config.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';

import * as ConfigActions from './config.actions';

@Injectable()
export class ConfigEffects {
  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private configService: ConfigService
  ) {
  }

  getInitialLayout$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(ConfigActions.GET_INITIAL_LAYOUT),
    mergeMap(({ application }) => {
      return this.apiService.getClientInfo(application).pipe(
        map((response) => {
          const tim = timer(1000, 1000).pipe(take(1));
          tim.subscribe((t) => this.configService.initialLoadingStop());

          return {
            type: ConfigActions.GET_INITIAL_LAYOUT_SUCCESS,
            payload: response,
          };
        }),
        catchError((error) =>
          of({
            type: ConfigActions.CONFIG_FAILURE,
            payload: error,
          })
        )
      );
    })
  ));
}
